import { render, staticRenderFns } from "./PostAtualizacao.vue?vue&type=template&id=db2639c0"
import script from "./PostAtualizacao.vue?vue&type=script&lang=js"
export * from "./PostAtualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports